const messages: Record<string, string> = {
	'loader.loading': 'Loading data ...',
	'loader.error': 'Your process could not be loaded. Please try again later...',
	'connectionError.title': 'Connection error',
	'connectionError.description': 'Connection error. Please upload picture again.',
	'mainError.tryAgain': 'Try again',
	'landing.headline.policyCheck': 'Welcome',
	'landing.paragraph': 'You are three steps away from finishing the process',
	'landing.stepDescription.fourAdditionalPictures': 'Take the required pictures',
	'landing.stepDescription.fourDiagonalPerspectives': 'Upload pictures',
	'landing.stepDescription.feedback': 'Give us your feedback',
	'landing.termsAndConditionsLinkDescription': ' ',
	'landing.termsAndConditionsLink': 'Accept the terms and conditions',
	'button.start': 'Start',
	'landing.aboutPolicyCheck': 'What the PolicyCheck is?',
	'chooseLang.headline': 'Choose your preferred language',
	'button.close': 'Close',
	'tutorialModal.headline.first.policyCheck': 'What is behind PolicyCheck?',
	'tutorialModal.paragraph.second':
		'PolicyCheck is a quick vehicle inspection. The inspection process consists of 8 simple steps.',
	'tutorialModal.paragraph.first.policyCheck': ' ',

	'landing.additional-informations-section.title':
		'Before starting the inspection of your vehicle, check that:',
	'landing.additional-informations-section.text':
		'<ul><li>You have the keys and the registration certificate at hand</li><li>You are in a place with good light and mobile network</li><li>The vehicle is accessible from all angles and all side windows are closed </li></ul>',

	'vehicleImages.overviewPhotos': 'Vehicle overview photos',
	'vehicleImages.overviewPhotos.subtitle': 'Photograph vehicle',
	'vehicleImages.description':
		'Photograph your vehicle diagonally front left and right, rear left and right. The license plate must be visible in all pictures.',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Photo of the front left diagonal',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Photo of the rear left diagonal',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Photo of the rear right diagonal',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Photo of the front right diagonal',
	'button.next': 'Next',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Exemplary photo',
	'imageRecognitionMismatchModal.headline': 'Are you sure you added the right photo ?',
	'button.continue': 'Continue',
	'button.backchangeImage': 'Back & change image',
	'completeVehicleImagesModal.headline': 'Hint',
	'completeVehicleImagesModal.description': 'Please add the following information',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Photo of the vehicle front left',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Photo of the vehicle back left',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Photo of the vehicle front right',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Photo of the vehicle back right',
	'button.changeImage': 'Change the photo',
	'button.deleteImage': 'Delete the photo',
	'vehicleImages.leftFrontOverview': 'Diagonal photo of the front - left side',
	'vehicleImages.leftRearOverview': 'Diagonal photo of the rear - left side',
	'vehicleImages.rightRearOverview': 'Diagonal photo of the rear - right side',
	'vehicleImages.rightFrontOverview': 'Diagonal photo of the front - right side',
	'fourPerspectivesExampleModal.headline.first': 'Exemplary photo',
	'fourPerspectivesExampleModal.button.close': 'Close',

	'fourAdditionalPictures.title': 'Additional pictures',
	'fourAdditionalPictures.overallDashboard.title': "Vehicle's dashboard",
	'fourAdditionalPictures.overallDashboard.description':
		"Photograph your vehicle's dashboard completely.",
	'fourAdditionalPictures.mileage.title': 'Odometer',
	'fourAdditionalPictures.mileage.description':
		'Please take a photo of your mileage. If your vehicle has a digital display, please switch it on.',
	'fourAdditionalPictures.mileage.enter': "Enter the vehicle's mileage",
	'dashboardMileage.placeholder': 'for example 150000 km',
	'fourAdditionalPictures.windshield.title': "Vehicle's front windshield",
	'fourAdditionalPictures.windshield.description':
		"Please take a detailed photo of your vehicle's front windshield",
	'fourAdditionalPictures.vin.title': "Vehicle's VIN number",
	'fourAdditionalPictures.vin.description':
		"Please take a photo of your vehicle's VIN number. You could find this on the driver's door seal or the bottom left corner of the windshield.",
	'overallDashboardImage.title': 'Overall dashboard image',
	'dashboardMileage.dashboard.title': 'Photo of the mileage',
	'windshieldImage.title': 'Windshield image',
	'vinPicture.title': 'Photo of the VIN number',
	'completeFourAdditionalPicturesModal.headline': 'Hint',
	'completeFourAdditionalPicturesModal.description': 'Please add the following information',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage':
		'Photo of the vehicle´s dashboard',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Photo of the mileage',
	'completeDashboardMileageModal.hasValidMileage': 'The vehicle mileage',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Photo of the vehicle´s VIN number',
	'completeFourAdditionalPicturesModal.hasWindshieldImage':
		'Photo of the vehicle´s front windshield',

	'feedback.headline.policyCheck': 'Pictures received successfully!',
	'feedback.description': ' ',
	'feedback.rating.policyCheck':
		'With how many stars would you rank your experience with the app, being 5 the best score?',
	'feedback.yourOpinion': 'Comments?',
	'feedback.button.send': 'Submit',
	'waitForAudit.thankYou': 'We appreciate your feedback!',
	'waitForAudit.description.damageFound': 'Thank you for trusting in BBVA Allianz',
	'thanks.headline.first': 'Thank you!',
	'thanks.paragraph.first': 'Thank you for trusting in BBVA Allianz',

	'fourAdditionalPictures.overallDashboard.exampleModalTitle':
		'Exemplary photo - Photo of the vehicle´s dashboard',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Exemplary photo - Photo of the mileage',
	'fourAdditionalPictures.windshield.exampleModalTitle':
		'Exemplary photo - Photo of the vehicle´s front windshield',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Exemplary photo - Photo of the VIN number',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Exemplary photo - Photo of the vehicle front left',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle':
		'Exemplary photo - Photo of the vehicle back left',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Exemplary photo - Photo of the vehicle back right',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'Exemplary photo -  Photo of the vehicle front right',

	'invalidFile.size.title': 'Incorrect image size',
	'invalidFile.size.description': 'The image size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
};

export default messages;
